import { render } from "./CalculationId.vue?vue&type=template&id=07a143f7&scoped=true&ts=true"
import script from "./CalculationId.vue?vue&type=script&lang=ts"
export * from "./CalculationId.vue?vue&type=script&lang=ts"

import "./CalculationId.vue?vue&type=style&index=0&id=07a143f7&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a143f7"]])

export default __exports__